import styled, { css } from 'styled-components';

export type SlideProps = {
  /**
   * Horizontal alignment for `side: [left | right]` or<br>
   * vertical alignment for `side: [top | bottom]`.
   */
  align?: 'start' | 'center' | 'end',
  /**
   * Duration of the animation in milliseconds.
   */
  duration?: number,
  /**
   * Side to slide from.
   */
  side?: 'top' | 'right' | 'bottom' | 'left',
  /**
   * Triggers the animation.
   */
  visible?: boolean
}

export const Slide = styled.div<SlideProps>`
  position: absolute;
  z-index: 1;
  opacity: ${props => (props.visible ? 1 : 0)};

  ${props => props.side}: 0;

  ${props => (props.side === 'top' || props.side === 'bottom') && css`
    ${props.align === 'center' && css`
      left: 50%;
    `};
    ${props.align === 'start' && css`
      left: 0;
    `};
    ${props.align === 'end' && css`
      right: 0;
    `};

    transform:
      translateX(${props.align === 'center' ? -50 : 0}%)
      translateY(${props.side === 'top' ? '-' : ''}${props.visible ? 0 : 100}%);
  `};

  ${props => (props.side === 'left' || props.side === 'right') && css`
    ${props.align === 'center' && css`
      top: 50%;
    `};
    ${props.align === 'start' && css`
      top: 0;
    `};
    ${props.align === 'end' && css`
      bottom: 0;
    `};

    transform:
      translateX(${props.side === 'left' ? '-' : ''}${props.visible ? 0 : 100}%)
      translateY(${props.align === 'center' ? -50 : 0}%);
  `};

  transition:
    transform ${props => props.duration}ms ease-in,
    opacity ${props => props.duration}ms ease-in;
`;

Slide.defaultProps = {
  duration: 200,
  side: 'top',
  align: 'start',
  visible: false
};

Slide.displayName = 'Slide';
